export enum CoaNameEnum {
  INCOME = "INCOME",
  COST_OF_SALES = "COST OF SALES",
  NET_PROFIT = "NET PROFIT",
}